/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import { Component, OnInit } from '@angular/core';
import { FinancialPlanningService } from '../services/financial-planning.service';
import { InstallerTrackingResource } from 'src/app/client-api.service';
import { MaintenanceService } from '../services/maintenance.service';
import { DateUtils } from 'src/app/shared/date-utils';
import { TableColumn } from 'src/app/shared/tcc-ui/tables';
import { PanelSize } from 'src/app/shared/tcc-ui/simple-panel/models';
import { map } from 'rxjs/operators';


@Component({
  selector: 'app-financial-planning-installer-tracking',
  templateUrl: './financial-planning-installer-tracking.component.html',
})
export class FinancialPlanningInstallerTrackingComponent implements OnInit {

  state: 'initializing' | 'loading' | 'ready' | 'saving';
  tabs: string[] = ['Installer', 'Tracking'];
  panalSize: PanelSize = 'large';
  activeTab = 0;
  rows: InstallerTrackingResource[] | undefined;
  columns: TableColumn<InstallerTrackingResource>[] | undefined;
  hasNoChildBladesOpen = false;
  installerTracking$ = this.fpService.installerTracking$;
 
  constructor(private fpService: FinancialPlanningService,
              private maintenanceService: MaintenanceService ) {
    this.state = 'initializing';
    this.columns = [
      { title: 'Id', name: 'id', hidden: true },            
      { title: 'Start', name: 'startDateTimeUtc', contentResolver: (_, row) => DateUtils.longDateFormatter(DateUtils.convertToEst(row?.startDateTimeUtc!))?.toString()! },            
      { title: 'End', name: 'endDateTime', contentResolver: (_, row) => DateUtils.longDateFormatter(DateUtils.convertToEst(row?.endDateTime!)!)?.toString()! },
      { title: 'Duration (min)', name: 'startDateTimeUtc', contentResolver: (_, row) => this.getDuration(row?.startDateTimeUtc!, row?.endDateTime!).toString() },
      { title: 'Command', name: 'command' },
      { title: 'User Name', name: 'userName' },
      { title: 'Results', name: 'results', contentResolver: (_, row) => row?.results!}
    ];
  }

  ngOnInit(): void {    
    this.maintenanceService.setMaintenanceComponenetPanelSize('full');

    this.installerTracking$.pipe(
      map(installerTracking => {
        if(installerTracking.some(t => t.command === '-d')){
          // set flag here to to indicate -d was run
        }
        return installerTracking;
      })).subscribe(res => {
            this.rows = res;
            for( const r of this.rows) {
              r.results = r.results?.replace(/\r\n/g, '<br />');
            }
            this.state = 'ready';
          },
          err => {
            this.state = 'ready';
            alert('Error getting installer tracking records!');
          }
        );
  }

  getDuration(startDate: Date, endDate: Date) {
    const duration = Math.round((((endDate.valueOf() - startDate.valueOf()) % 86400000) % 3600000) / 60000); // minutes
    return duration;
  }

  // Tracking selector
  setActiveTab(index: number): void {    
    this.activeTab = index;
  }

  rowClicked(event: any) {

  }

}
